import { Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui"
import { XIcon } from "lucide-react"

type TimeUnit = "minutes" | "hours" | "days";

type TimeSelectProps = {
  value: {value: number, unit: TimeUnit};
  onChange: (value: {value: number, unit: TimeUnit}) => void;
  onRemove: () => void;
  isFirst: boolean;
  description?: string;
};

export const TimeSelect = ({
  value,
  onChange,
  onRemove,
  isFirst,
  description,
}: TimeSelectProps) => {

  return (
    <div className="flex items-center  gap-[1px]">
      <Input
        type="number"
        min="1"
        step="1"
        inputMode="numeric"
        placeholder="1"
        className="h-12 block w-20  rounded-r-none border-r-[1px]"
        value={value.value}
        onChange={(e) => onChange({value: Number(e.target.value), unit: value.unit})}
      />
      <Select onValueChange={(select) => onChange({value: value.value, unit: select as TimeUnit})} value={value.unit}>
        <SelectTrigger className="w-full sm:w-[120px] bg-white h-12 border-l-0 rounded-l-none">
          <SelectValue placeholder="Unit" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="minutes">Minutes</SelectItem>
          <SelectItem value="hours">Hours</SelectItem>
          <SelectItem value="days">Days</SelectItem>
        </SelectContent>
      </Select>
      <p className="font-light ml-2 text-gray-500 dark:text-gray-400">{description || 'Sends before the appointment.'}</p>
      {!isFirst && <XIcon className="size-6 cursor-pointer font-light " onClick={onRemove} />}
    </div>
  )
}